import React, { useState } from 'react';

import LabelledInput from '@ordermentum/ui-shared/molecules/LabelledInput';
import Banner from '@ordermentum/ui-shared/atoms/Banner';

import {
  SignInLabelContainer,
  SignInText,
  FormWrapper,
  FieldWrapper,
  ErrorBannerWrapper,
} from './index.styles';
import { SubmissionButton } from './LoginForm';
import { SignInContainer } from '../LoginBase.styles';

type PasswordResetAfterFormProps = {
  // Receive entered password. Return true if the submission was successful,
  // false if something went wrong.
  // This function should also handle redirection.
  onSubmit: (password: string) => Promise<boolean>;
  error: string | undefined;
};

export const PasswordEntryForm = ({
  onSubmit,
  error,
}: PasswordResetAfterFormProps) => {
  const [password, setPassword] = useState<string>('');
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  return (
    <SignInContainer>
      <SignInLabelContainer>
        <SignInText>Enter your new password</SignInText>
      </SignInLabelContainer>
      {error && (
        <ErrorBannerWrapper>
          <Banner type="warning" noIcon dismiss={false}>
            {error}
          </Banner>
        </ErrorBannerWrapper>
      )}
      <form
        onSubmit={async f => {
          f.preventDefault();
          setSubmitting(true);
          const success = await onSubmit(password);
          if (!success) {
            setSubmitting(false);
          }
        }}
      >
        <FormWrapper>
          <FieldWrapper>
            <LabelledInput
              label="Password"
              required
              tag="password"
              type="password"
              value={password}
              onChange={(_, val) => setPassword(val)}
              size="max"
            />
          </FieldWrapper>
          <FieldWrapper>
            <SubmissionButton loading={isSubmitting}>
              Set password
            </SubmissionButton>
          </FieldWrapper>
        </FormWrapper>
      </form>
    </SignInContainer>
  );
};
